import Vue from 'vue';
import LiquorTree from 'apollo11-tree'
// global registration
Vue.use(LiquorTree);
